import ColumnBase from "./ColumnBase.jsx";
import { ColumnStore } from "@bryntum/schedulerpro";
import { WIDGET_KEYS } from "../../other/constants/WidgetKeys.jsx";
import { ICON_COL_DEF_WIDTH, SwivuDocumentType } from "../../other/constants/OtherKeys.jsx";
import { defaultGroupRenderer } from "../../other/utils/utils.jsx";
import { HasIconColumnTooltipMixin } from "./mixins/HasIconColumnTooltipMixin.jsx";

const getEntityIcon = (hasData = false) => {
  const color = hasData ? "text-[#0a88e9]" : "";
  return `<i class="swivu-media-icon-tooltip fa-regular fa-folder-open ${color}"></i>`;
};

export default class FilesColumn extends HasIconColumnTooltipMixin(ColumnBase) {
  static get $name() {
    return "FilesColumn";
  }

  static get type() {
    return WIDGET_KEYS.filesColumn;
  }

  static get defaults() {
    return {
      text: "File",
      width: 30,
      minWidth: ICON_COL_DEF_WIDTH,
      editor: false,
      searchable: false,
      align: "center",
      field: "hasFiles",
      cellCls: "cursor-pointer",
      cls: "swivu-icon-column",
      sealed: true,
      filterable: false,
      htmlEncode: false,
      renderer({ value }) {
        return getEntityIcon(value);
      },
      groupRenderer({ groupRowFor, ...rest }) {
        return defaultGroupRenderer({ groupRowFor: getEntityIcon(groupRowFor), ...rest });
      },
      headerRenderer() {
        return getEntityIcon();
      }
    };
  }

  getTooltipSelector() {
    return ".swivu-media-icon-tooltip";
  }

  getTooltipItems(record) {
    const fileRecords = this.project.boardFilesStore.query(file => {
      if (record.isTask || record.isPlanTaskModel) return file.taskId === record.id;
      if (record.isResource) return file.resourceId === record.id;
      if (record.isClient) return file.clientId === record.id;

      return false;
    });

    return fileRecords;
  }

  formatTooltipItems(records) {
    return records.map((record, index) => {
      const originalRecord = record
      record = record.swivuDocumentRecordMapping;
      // Limit description to a reasonable length
      const description = record.name || "";
      const truncatedDescription = description.length > 50 ?
        description.substring(0, 50) + "..." : description;

      return {
        tag: "div",
        dataset: {
          documentId: originalRecord.id,
          source: record.source,
        },
        class: `tooltip-contact-container flex flex-col gap-2 ${index > 0 ? 'pt-3 mt-3 border-t border-border' : ''}`,
        children: [
          {
            tag: "div",
            class: "contact-pill contact-header font-medium text-sm cursor-pointer hover:bg-accent/80 transition-colors rounded-md px-3 py-2",
            html: `
              <div class="flex items-center gap-2">
                <img
                  src="${record.thumbnailImageUrl}"
                  alt="${record.name}"
                  class="w-10 h-10 rounded border border-border object-cover flex-shrink-0"
                  onerror="this.src='https://www.iconpacks.net/icons/2/free-file-icon-1453-thumb.png'"
                />
                <div class="flex-1 min-w-0 flex flex-col gap-1">
                  <div class="truncate text-sm font-medium text-foreground">${truncatedDescription || "Untitled Media"}</div>
                  <div class="truncate text-xs text-muted-foreground">Added By: ${record.addedBy || 'N/A'}</div>
                </div>
              </div>
            `,
          }
        ]
      };
    });
  }

  handleTooltipClick(event, _record) {
    if (this.onDocumentTimeout) clearTimeout(this.onDocumentTimeout);

    this.onDocumentTimeout = setTimeout(() => {
      const tooltipFileContainerEl = event.target.closest(".tooltip-contact-container");
      if (!tooltipFileContainerEl) return;

      // Check if it's a Swivu file
      if ((+tooltipFileContainerEl.dataset.source) === SwivuDocumentType.swivuFile) {
        const fileRecord = this.project.boardFilesStore.getById(tooltipFileContainerEl.dataset.documentId);
        if (!fileRecord) return;

        // Open file in new tab
        window.open(fileRecord.url, '_blank');
      }
    }, 100);
  }
}

ColumnStore.registerColumnType(FilesColumn);
